import { render } from "./NcrmContactsBulkBar.vue?vue&type=template&id=45b1cbf6"
import script from "./NcrmContactsBulkBar.vue?vue&type=script&lang=js"
export * from "./NcrmContactsBulkBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__